import FavoriteCategoryNode from './FavoriteCategoryNode';
import FavoriteFolderNode from './FavoriteFolderNode';
import FavoritePersonaNode from './FavoritePersonaNode';
import FavoriteSearchNode from './FavoriteSearchNode';
import { observer } from 'mobx-react-lite';
import { favoritesStore } from 'owa-favorites';
import { FolderForestNodeType } from 'owa-favorites-types';
import folderStore from 'owa-folders';
import publicFolderFavoriteStore from 'owa-public-folder-favorite/lib/store/publicFolderFavoriteStore';
import * as React from 'react';
import type { MailboxInfo } from 'owa-client-types';

export interface FavoriteNodeCommonProps {
    favoriteId: string;
    mailboxInfo: MailboxInfo;
}

const FavoriteNode = observer(function FavoriteNode(props: FavoriteNodeCommonProps) {
    const id = props.favoriteId;
    if (favoritesStore.favoritesPersonaNodes.has(id)) {
        const personaNode = favoritesStore.favoritesPersonaNodes.get(id);

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (28,13): Object is possibly 'undefined'.
        // @ts-expect-error
        if (personaNode.mainEmailAddress) {
            return (
                <FavoritePersonaNode
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2532 (35,34): Object is possibly 'undefined'.
                    // @ts-expect-error
                    displayName={personaNode.displayName}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2532 (39,35): Object is possibly 'undefined'.
                    // @ts-expect-error
                    emailAddress={personaNode.mainEmailAddress}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2322 (43,21): Type 'string | undefined' is not assignable to type 'string'.
                    // @ts-expect-error
                    personaId={personaNode.personaId}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2322 (47,21): Type 'string | undefined' is not assignable to type 'string'.
                    // @ts-expect-error
                    searchFolderId={personaNode.searchFolderId}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2322 (51,21): Type 'DropViewState | undefined' is not assignable to type 'DropViewState'.
                    // @ts-expect-error
                    dropViewState={personaNode.dropViewState}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2532 (55,34): Object is possibly 'undefined'.
                    // @ts-expect-error
                    isJustAdded={personaNode.isJustAdded}
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2532 (59,46): Object is possibly 'undefined'.
                    // @ts-expect-error
                    isSearchFolderPopulated={personaNode.isSearchFolderPopulated}
                    {...props}
                />
            );
        }
    } else if (favoritesStore.favoritesFolderNodes.has(id)) {
        const folderNode = favoritesStore.favoritesFolderNodes.get(id);
        const isPublicFolder = folderNode && folderNode.type === FolderForestNodeType.PublicFolder;
        const folder = isPublicFolder
            ? publicFolderFavoriteStore.folderTable.get(id)
            : folderStore.folderTable.get(id);

        if (folder) {
            return <FavoriteFolderNode folderId={id} isPublicFolder={isPublicFolder} {...props} />;
        }
    } else if (favoritesStore.favoriteSearches.has(id)) {
        const favoriteSearch = favoritesStore.favoriteSearches.get(id);
        return (
            <FavoriteSearchNode
                searchQuery={id}
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2532 (84,32): Object is possibly 'undefined'.
                // @ts-expect-error
                dropViewState={favoriteSearch.dropViewState}
                {...props}
            />
        );
    } else if (favoritesStore.favoriteCategories.has(id)) {
        const favoriteCategory = favoritesStore.favoriteCategories.get(id);
        return (
            <FavoriteCategoryNode
                categoryId={id}
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2532 (96,32): Object is possibly 'undefined'.
                // @ts-expect-error
                dropViewState={favoriteCategory.dropViewState}
                {...props}
            />
        );
    }

    return null;
});
export default FavoriteNode;
